export const environment = {
  api_url: 'https://moj.kinet.sk/api',
  stage: 'production',
  enable_custom_payment_amount: true,
  disable_2fa_prompt: true,
};
